const Constants = {
    initialMonthRange: [new Date().toISOString().slice(0, 10), new Date().toISOString().slice(0, 10)],
}

export default Constants
